class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

    if (typeof selectMyFilterMaterial == "function") window.selectMyFilterMaterial();
  }

  static reinitializePagination() {
    if (window.collectionPaginationReinitTimer) {
      clearTimeout(window.collectionPaginationReinitTimer);
    }

    FacetFiltersForm.initInfiniteScroll();

    requestAnimationFrame(() => {
      FacetFiltersForm.initInfiniteScroll();
    });

    window.collectionPaginationReinitTimer = setTimeout(() => {
      FacetFiltersForm.initInfiniteScroll();
    }, 300);
  }

  static scheduleInfiniteScroll() {
    FacetFiltersForm.reinitializePagination();
  }

  static runScrollAnimationTrigger(html) {
    try {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      if (typeof initializeScrollAnimationTrigger === 'function') {
        initializeScrollAnimationTrigger(parsedHTML);
      }
    } catch (error) {
      console.error('Scroll animation init failed:', error);
    }
  }

  static initInfiniteScroll() {
    const target = document.querySelector('#product-grid-Pagination');

    if (window.collectionPaginationObserver) {
      window.collectionPaginationObserver.disconnect();
      window.collectionPaginationObserver = null;
    }

    if (!target) return;

    const paginationLink = target.querySelector('.link-infinity, a.btn');
    if (!paginationLink) return;

    const loadNextPage = () => {
      const pagination = document.querySelector('#product-grid-Pagination');
      const link = pagination?.querySelector('.link-infinity, a.btn');

      if (!link || link.dataset.paginationLoading === 'true') return;

      const rotating = pagination?.querySelector('.rotating');
      if (rotating) rotating.style.display = 'block';

      if (typeof window.onClickCollectionPagination === 'function') {
        window.onClickCollectionPagination(link, { preventDefault: () => {} });
      } else {
        link.click();
      }
    };

    const isPaginationInView = (element) => {
      const rect = element.getBoundingClientRect();
      return rect.top <= window.innerHeight + 300 && rect.bottom >= 0;
    };

    window.collectionPaginationObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadNextPage();
          }
        });
      },
      { rootMargin: '300px 0px' }
    );

    window.collectionPaginationObserver.observe(target);
    window.observer1 = window.collectionPaginationObserver;

    if (isPaginationInView(target)) {
      loadNextPage();
    }
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        closeFilter();
        ReloadSmartWishlist();
        if(window.innerWidth>750){  
            priceBaeSlider();
            onLoadPrice();
        }else{
          priceBaeSliderM();
          onLoadPriceM();
        }

        try {

        if (typeof window.initBestSellerSwiper === 'function') {
          window.initBestSellerSwiper();
        }

         if (typeof window.renderDynamicNewArrival === 'function') {
          window.renderDynamicNewArrival();
        }
        

          
        if (typeof window.renderBestSellerProducts === 'function') {
          window.renderBestSellerProducts();
        }

          if (typeof window.dynamicYouMightBe === 'function') {
          window.dynamicYouMightBe();
        }
      
          setTimeout(function() {
          if (typeof window.initTrendingNowSwiper === 'function') {
            window.initTrendingNowSwiper();
          }
        }, 3000);
      
        if (typeof window.initCustomMainRecommened === 'function') {
          window.initCustomMainRecommened();
        }
      
        if (typeof window.youmightbeproducts === 'function') {
          window.youmightbeproducts();
        }

      
        if (typeof window.cloneActiveFilters === 'function') {
          window.cloneActiveFilters();
        }

        if (typeof window.initTrendingNowSwiper === 'function') {
          window.checkMobileFilterMenu();
        }

        if (typeof window.initTrendingNowSwiper === 'function') {
          window.selectMyFilterMaterial();
        }
        } finally {
          FacetFiltersForm.runScrollAnimationTrigger(html);
          FacetFiltersForm.reinitializePagination();
          FacetFiltersForm.reinitPlpProductCardSwipers();
          setTimeout(() => FacetFiltersForm.reinitializePagination(), 600);
        }
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof updateCompareOnLoad === 'function') {
      updateCompareOnLoad();
    }
    try {
    if(window.innerWidth>750){  
            priceBaeSlider();
            onLoadPrice();
    }else{
          priceBaeSliderM();
          onLoadPriceM();
    }
    if (typeof window.refreshPlpFilterSticky === 'function') window.refreshPlpFilterSticky();
    } finally {
      FacetFiltersForm.runScrollAnimationTrigger(html);
      FacetFiltersForm.reinitializePagination();
      setTimeout(() => FacetFiltersForm.reinitializePagination(), 600);
    }
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    const collection = document.getElementById('ProductGridContainer')?.querySelector('.collection');
    if (collection) {
      collection.classList.remove('loading');
    }

    FacetFiltersForm.reinitializePagination();
    FacetFiltersForm.reinitPlpProductCardSwipers();
  }

  static reinitPlpProductCardSwipers() {
    const runInit = () => {
      const productGrid = document.querySelector('#product-grid');
      if (productGrid) {
        productGrid.style.removeProperty('z-index');
        productGrid.style.removeProperty('position');
      }

      const plpGrid = document.getElementById('ProductGridContainer');
      const container = plpGrid || document;

      if (typeof window.reinitializeProductCardSwipers === 'function') {
        window.reinitializeProductCardSwipers(container);
      } else if (typeof window.initializeProductCardSwipers === 'function') {
        window.initializeProductCardSwipers(container);
      }
    };

    requestAnimationFrame(() => {
      requestAnimationFrame(runInit);
    });
  }

  static renderProductCount(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const productCountEl = parsedHTML.getElementById('ProductCount');

    if (productCountEl) {
      const count = productCountEl.innerHTML;
      const container = document.getElementById('ProductCount');
      const containerDesktop = document.getElementById('ProductCountDesktop');
      const container1Desktop = document.querySelector('#desktopCount b');
      if (container) {
        container.innerHTML = count;
        container.classList.remove('loading');
      }
      if (containerDesktop) {
        containerDesktop.innerHTML = count;
        if (container1Desktop) container1Desktop.innerHTML = count;
        containerDesktop.classList.remove('loading');
      }
    }

    const mobileCountSource = parsedHTML.getElementById('ProductCountMobile');
    const mobileCountTarget = document.getElementById('ProductCountMobile');
    if (mobileCountSource && mobileCountTarget) {
      mobileCountTarget.textContent = mobileCountSource.textContent;
    }

    const desktopPlpSource = parsedHTML.getElementById('ProductCountDesktopPlp');
    const desktopPlpTarget = document.getElementById('ProductCountDesktopPlp');
    if (desktopPlpSource && desktopPlpTarget) {
      desktopPlpTarget.textContent = desktopPlpSource.textContent;
    }

    if (typeof updateCompareOnLoad === 'function') {
      updateCompareOnLoad();
    }
    closeFilter();
    ReloadSmartWishlist();
    if (typeof window.refreshPlpFilterSticky === 'function') window.refreshPlpFilterSticky();
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    // document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }

    setTimeout(function() {
      if (window.selectMyFilter) {
        window.selectMyFilter();
      }
    }, 100); 
    
  
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));


      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
    document.querySelectorAll('.sorting_list')?.forEach((e)=>{
      e.classList.remove('actives');
    });
  }
}

customElements.define('facet-remove', FacetRemove);

window.infinteScroll = function () {
  FacetFiltersForm.reinitializePagination();
};

window.reinitializeCollectionPagination = function () {
  FacetFiltersForm.reinitializePagination();
};

window.onClickCollectionPagination = async function (link, event) {
  if (link.dataset.paginationLoading === 'true') return;
  event?.preventDefault?.();
  link.dataset.paginationLoading = 'true';

  link.style.width = `${link.offsetWidth}px`;
  link.style.height = `${link.offsetHeight}px`;
  link.innerHTML = `
    <div class="spinner-border spinner-border-sm mx-auto" role="status" style="width: 1.2rem; height: 1.2rem">
      <span class="visually-hidden">Loading...</span>
    </div>
  `;

  try {
    const response = await fetch(link.getAttribute('href'));
    const data = await response.text();
    const newDocument = new DOMParser().parseFromString(data, 'text/html');
    const productGrid = document.querySelector('.collection .product-grid');
    const nextGrid = newDocument.querySelector('.collection .product-grid');

    if (productGrid && nextGrid) {
      productGrid.insertAdjacentHTML('beforeend', nextGrid.innerHTML);
    }

    if (typeof window.initializeProductCardSwipers === 'function') {
      FacetFiltersForm.reinitPlpProductCardSwipers();
    }
    if (typeof window.initBestSellerSwiper === 'function') window.initBestSellerSwiper();
    if (typeof window.renderBestSellerProducts === 'function') window.renderBestSellerProducts();
    if (typeof window.renderDynamicNewArrival === 'function') window.renderDynamicNewArrival();
    if (typeof window.dynamicYouMightBe === 'function') window.dynamicYouMightBe();
    if (typeof window.initCustomMainRecommened === 'function') window.initCustomMainRecommened();
    if (typeof window.youmightbeproducts === 'function') window.youmightbeproducts();
    if (typeof window.cloneActiveFilters === 'function') window.cloneActiveFilters();
    if (typeof window.checkMobileFilterMenu === 'function') window.checkMobileFilterMenu();
    if (typeof window.selectMyFilterMaterial === 'function') window.selectMyFilterMaterial();

    setTimeout(function () {
      if (typeof window.initTrendingNowSwiper === 'function') window.initTrendingNowSwiper();
    }, 3000);

    const nextPagination = newDocument.querySelector('#product-grid-Pagination');
    const currentPagination = document.querySelector('#product-grid-Pagination');

    if (currentPagination && nextPagination) {
      currentPagination.replaceWith(nextPagination);
    }

    link.dispatchEvent(new CustomEvent('ks.collection.paginated'));

    if (typeof ReloadSmartWishlist === 'function') ReloadSmartWishlist();

    FacetFiltersForm.reinitializePagination();
  } finally {
    link.dataset.paginationLoading = 'false';
  }
};

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('#product-grid-Pagination')) {
    FacetFiltersForm.reinitializePagination();
  }
});